import React from 'react';

import { Table, Text } from '../../../app-components';
import { MODELS } from '../../../Lib/constants';
import { getUser } from '../../../AppServices';
import { getUserRole, shorten } from '../../../Lib/helpers';

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Name',
        type: 'text',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {shorten(item?.ar?.dms?.name, 18)}
          </Text>
        ),
      },
      {
        header: 'Phone#',
        type: 'text',
        width: 200,
        field: 'ar.dms.contactNumber',
      },
      {
        header: 'Date Generated',
        type: 'date',
        field: 'onDate',
        width: 200,
      },
      {
        header: 'VIN',
        type: 'text',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {shorten(item?.ar?.dms?.vin, 20)}
          </Text>
        ),
      },
      {
        header: 'Year',
        type: 'text',
        field: 'ar.dms.year',
        width: 200,
      },
      {
        header: 'Make',
        type: 'text',
        field: 'ar.dms.make',
        width: 200,
      },
      {
        header: 'Model',
        type: 'text',
        field: 'ar.dms.model',
        width: 200,
      },
      {
        header: 'Mileage',
        type: 'text',
        field: 'ar.dms.mileage',
        width: 200,
      },
      // {
      //   header: 'Appraisal #',
      //   type: 'text',
      //   field: 'uci.repairOrderNumber',
      //   width: 200,
      // },

      {
        header: 'Range',
        type: 'text',
        width: 200,
        field: 'ar.finalRange',
      },
    ],
  },
};

export default Table({
  uri: () => {
    const user = getUser();
    const userRole = getUserRole();
    const addOnFilter = {};

    if (userRole === 'dealer' || userRole === 'superdealer') {
      addOnFilter.name = user.username;
    } else if (userRole === 'employee') {
      addOnFilter.name = user.dealer.username;
    }

    return {
      query: {
        id: 'listAll',
        addOnFilter,
      },
      aggregate: true,
      model: MODELS.SMSOfferCount,
    };
  },
  ...tableItems,
});
